import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { NoticeCard } from 'components/NoticeCard';
import { useMediaQuery } from 'helpers/mediaQuery';

export function NotFoundLayout() {
  const { t } = useTranslation();

  const isScreenSm = useMediaQuery({ maxWidth: 'sm' });

  return (
    <div
      className={cn('flex h-[calc(100%-3rem)] min-h-[200px] justify-center', {
        'items-center px-10 pb-11 pt-8': !isScreenSm,
        'px-6 pb-8 pt-6': isScreenSm,
      })}
    >
      <div className={cn('flex justify-center', { 'py-12': !isScreenSm })}>
        <NoticeCard
          text={t('page.notFound.noticeCard.data.text')}
          title={t('page.notFound.noticeCard.data.title')}
        />
      </div>
    </div>
  );
}
